import type { LabDefinition } from "../types";

export const labs: LabDefinition[] = [
  {
    id: "overview",
    eyebrow: "00 / FIELD GUIDE",
    title: "Choose the cheapest renderer",
    summary: "A decision map, capability matrix and live runtime readout.",
    tags: ["architecture", "budgets"],
    accent: "#d8ff59",
  },
  {
    id: "css",
    eyebrow: "01 / PLATFORM",
    title: "CSS & native motion",
    summary: "Compositor-safe motion, view timelines and progressive enhancement.",
    tags: ["CSS", "WAAPI"],
    accent: "#6ee7ff",
  },
  {
    id: "motion",
    eyebrow: "02 / REACT",
    title: "Motion state & layout",
    summary: "Springs, gestures, presence and shared-layout continuity.",
    tags: ["Motion", "FLIP"],
    accent: "#ff7ac8",
  },
  {
    id: "gsap",
    eyebrow: "03 / TIMELINE",
    title: "GSAP scroll direction",
    summary: "Scrubbed timelines, pinning, stagger and optional Lenis smoothing.",
    tags: ["GSAP", "ScrollTrigger", "Lenis"],
    accent: "#b5ff6d",
  },
  {
    id: "story",
    eyebrow: "04 / NARRATIVE",
    title: "Scrollytelling chapters",
    summary: "Sticky visual, semantic steps and bidirectional narrative state.",
    tags: ["Scrollama", "sticky"],
    accent: "#ffbb55",
  },
  {
    id: "vector",
    eyebrow: "05 / VECTOR",
    title: "SVG, Lottie & Rive contract",
    summary: "Stroke choreography, authored animation and state-machine boundaries.",
    tags: ["SVG", "Lottie", "Rive"],
    accent: "#ff756d",
  },
  {
    id: "canvas",
    eyebrow: "06 / PIXELS",
    title: "Canvas particle field",
    summary: "DPR-aware rendering, pointer forces and lifecycle cleanup.",
    tags: ["Canvas 2D", "RAF"],
    accent: "#56c8ff",
  },
  {
    id: "three",
    eyebrow: "07 / SPACE",
    title: "Three / R3F scene",
    summary: "Lighting, instancing, adaptive DPR and observable renderer cost.",
    tags: ["Three.js", "R3F", "Drei"],
    accent: "#a58bff",
  },
  {
    id: "benchmark",
    eyebrow: "08 / EVIDENCE",
    title: "Renderer benchmark",
    summary: "Compare DOM and Canvas under the same object count and motion profile.",
    tags: ["FPS", "long tasks"],
    accent: "#ffffff",
  },
];
